// extracted by mini-css-extract-plugin
module.exports = {"select-loader":"loadingCard_select-loader__1fnWT"};